import {store} from "../index";
import { SIZE_OF_CHANGE_STEP } from "../constants/constants";

export const shiftSleevesAndLids = (oldHeight) => {
    const  sides = store.getState().buildValuesSides,
        height = store.getState().buildValues.height,
        sign = (oldHeight === height ? 0 : Math.round((height - oldHeight)/Math.abs(oldHeight - height)));
    for(let i = 0; i < sides.length; i++){
        for(let j = 0; j < sides[i].sleeves.length; j++){
            sides[i].sleeves[j].top += sign*SIZE_OF_CHANGE_STEP;
        }
        for(let j = 0; j < sides[i].lids.length; j++){
            if(sides[i].lids[j].top)
                sides[i].lids[j].top += sign*SIZE_OF_CHANGE_STEP;
        }
    }
    return sides;
};


// WEBPACK FOOTER //
// ./src/helpers/shiftSleevesAndLids.js